// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "checkbox__label-3GE-n";
var _4 = "footer_wrapper-q-qP7";
export { _1 as "__esModule", _2 as "mobile", _3 as "checkbox__label", _4 as "footer_wrapper" }
export default { "__esModule": _1, "mobile": _2, "checkbox__label": _3, "footer_wrapper": _4 }
